import { TUpdatePrivacy } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import axios from '../../common/axios';
import { getUsersQueryKey } from '../../common/profile/use-get-profile-query';
import { ENTITY } from './entity';

export const useUpdatePrivacyMutation = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TUpdatePrivacy) => {
      const req = await axios.patch(`${ENTITY}/privacy`, payload);
      return req.data;
    },
    onSuccess: async (_data, { isPrivate }) => {
      await qc.invalidateQueries({ queryKey: getUsersQueryKey() });

      enqueueSnackbar(isPrivate ? 'Your profile is now private' : 'Your profile is now public', {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
    onError: () => {
      enqueueSnackbar('Unable to update your privacy setting. Please try again.', {
        variant: 'error',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
  });
};
